import { emitRecoAddToCartButtonLabelEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking) => {
    return {
        ...cinemaTracking,
    };
};

export default (cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels) => {
    const event = {
        name: "scroll",
        features: [buildCinema(cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels)],
    };

    emitRecoAddToCartButtonLabelEvent({ promo_RecoAddToCartButton: "visible" }, event);
};
